import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { appData } from '@/lib/app-data';
import RelatedSection from './RelatedSection.vue';

export default /*@__PURE__*/_defineComponent({
  __name: 'YouMightAlsoLike',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(RelatedSection, {
    "title-key": "YouMightAlsoLike",
    apps: _unref(appData).youMightAlsoLike.apps
  }, null, 8, ["apps"]))
}
}

})